let baseURL = 'https://www.axxedu.org.cn/api/';
let wsUrl = "wss://api.axxedu.org.cn:2346";
let moblieUrl = 'https://m.axxedu.org.cn/'

export { baseURL, wsUrl, moblieUrl }; 



// WEBPACK FOOTER //
// ./src/config/index.js